// @flow
import { useQuery, type QueryResult } from 'react-query';
import { roles as rolesApi } from 'common/middleware/api';
import sortBy from 'lodash/sortBy';

import { Role } from 'common/models/internal/Role';

type Params = {
    clientId: string,
    includeDisabled?: boolean,
    roleType?: string
};
type Result = $ReadOnlyArray<Role>;

export const fetchRoles = async ({
    clientId,
    includeDisabled = false,
    roleType
}: Params): Promise<Result> => {
    const response = await rolesApi.post(
        { clientId },
        {
            filters: [
                !includeDisabled
                    ? {
                          name: 'status',
                          operation: 'EQUALS',
                          value: 'ACTIVE'
                      }
                    : null,
                roleType
                    ? {
                          name: 'roleType',
                          operation: 'EQUALS',
                          value: roleType
                      }
                    : null
            ].filter(Boolean)
        }
    );

    return sortBy(
        response.roles.map(role => Role.fromJS(role)),
        // keep default roles on top
        role => !role.isDefault()
    );
};

export default function useRoles({
    clientId,
    includeDisabled = false,
    roleType
}: Params): QueryResult<Result> {
    return useQuery({
        queryKey: ['roles', 'all', { includeDisabled, roleType }],
        queryFn: () => fetchRoles({ clientId, includeDisabled, roleType })
    });
}
